<template>
  <DModal :show-close="false" :isBgOverlay="true" @close="$emit('close')" :appendToBody="true"
          style="z-index: 12312312312312" :placeInTop="true">
    <div class="d-modal text-dark" id="d-create-task-for-user" slot="insertComponent">
      <div class="d-modal__header">
        <h2>Status fra oprettelsen</h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="d-modal__content">
        <div v-if="errorUsers.length > 0" class="show-response__banner show-response__banner--warning">
          <span class="icon-warning show-response__banner__icon"></span>
          <div class="show-response__banner__text">
            <strong>
              {{ errorUsers.length }}
              {{ errorUsers.length === 1 ? 'bruger kom ikke med på listen' : 'brugere kom ikke med på listen' }}
            </strong>
            <p>
              {{ errorUsers.length === 1 ? 'Denne bruger har' : 'Disse brugere har' }} opgaver med lønkode og burde
              have fået et tillæg, men mangler en oplysning. Ret det i siden 'Årsnorm', og hent opgaver med
              lønkoder igen.
            </p>
          </div>
        </div>
        <div v-else class="show-response__banner show-response__banner--ok">
          <span class="icon-checkmark-circle show-response__banner__icon"></span>
          <div class="show-response__banner__text">
            <strong>Alle relevante brugere kom med</strong>
            <p>Der er ingen brugere med opgaver med lønkode, der mangler oplysninger.</p>
          </div>
        </div>
        <Tabs :tabs="computedTabs"
              :selected="selectedTab"
              @select="selectedTab = $event">
        </Tabs>
        <table class="do-table marg-1-top">
          <thead>
          <tr>
            <th>Navn</th>
            <th v-if="selectedTab === 'error'">Hvad mangler</th>
            <th v-if="selectedTab === 'error'">Sådan løser du det</th>
            <th v-else>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="usersFiltered.length === 0">
            <td :colspan="selectedTab === 'error' ? 3 : 2" class="italic">
              {{ selectedTab === 'error' ? 'Ingen brugere mangler oplysninger' : 'Ingen brugere blev oprettet' }}
            </td>
          </tr>
          <tr v-for="user in usersFiltered" :key="user.user_id"
              :class="{'show-response__row--error': user.result === 'error'}">
            <td>{{ user.user_name }}</td>
            <template v-if="selectedTab === 'error'">
              <td>
                <span class="do-warning">{{ errorDescription(user.error) }}</span>
              </td>
              <td class="show-response__hint">{{ errorHint(user.error) }}</td>
            </template>
            <td v-else>
              <span class="show-response__ok">✔️ Oprettet</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../common/DModal.vue'
import ModalConfirmation from '../Modals/ModalConfirmation.vue'
import Tabs from '../common/Tabs.vue'

export default {
  components: {Tabs, ModalConfirmation, DModal},
  props: {
    users: {
      type: Array,
      default: () => []
    },
    schoolId: {},
    schoolYearId: {},
    schoolYear: {}
  },
  data () {
    return {
      selectedTab: 'error'
    }
  },
  computed: {
    usersSorted () {
      return this.users.slice().sort((a, b) =>
        a.user_name.localeCompare(b.user_name, 'da', {
          numeric: true,
          sensitivity: 'base'
        })
      )
    },
    errorUsers () {
      return this.usersSorted.filter(u => u.result === 'error')
    },
    okUsers () {
      return this.usersSorted.filter(u => u.result === 'ok')
    },
    computedTabs () {
      return [
        {id: 'error', title: `Ikke oprettet (${this.errorUsers.length})`},
        {id: 'ok', title: `Oprettet korrekt (${this.okUsers.length})`}
      ]
    },
    usersFiltered () {
      return this.usersSorted.filter(u => u.result === this.selectedTab)
    }
  },
  methods: {
    // Fejlen kommer fra backend som en streng (exception-besked). Normalisér den,
    // så vi kan matche kendte tilfælde uanset små variationer.
    normalizeError (error) {
      return String(error == null ? '' : error).trim()
    },
    errorDescription (error) {
      const err = this.normalizeError(error)
      if (err === 'No norm' || err === 'No user year') return 'Mangler bruttonorm eller ansættelsesperiode'
      if (err === 'user has no calendar') return 'Brugeren har ingen kalender'
      return err || 'Ukendt fejl'
    },
    errorHint (error) {
      const err = this.normalizeError(error)
      if (err === 'No norm' || err === 'No user year') {
        return "Udfyld brugerens bruttonorm og ansættelsesperiode i siden 'Årsnorm'."
      }
      if (err === 'user has no calendar') {
        return 'Kontakt support — brugeren mangler en kalender.'
      }
      return 'Tjek brugerens opsætning og prøv igen.'
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-modal {
  width: 1000px;
  border-radius: 16px;
  position: relative;
}

.show-response__banner {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.show-response__banner--warning {
  background: #fee2e2;
  border-color: #fecaca;
  color: #991b1b;
  text-transform: initial;
}

.show-response__banner--ok {
  background: #dcf3e3;
  border: 1px solid #a8dcb9;
  color: #1c7c43;
}

.show-response__banner__icon {
  font-size: 22px;
  line-height: 1.4;
  flex-shrink: 0;
}

.show-response__banner__text strong {
  display: block;
  font-size: 15px;
  margin-bottom: 0.25rem;
}

.show-response__banner__text p {
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
}

.show-response__row--error {
  background: #fffaf0;
}

.show-response__row--error:hover {
  background: #fff4d6;
}

.show-response__hint {
  color: #6b7280;
  font-size: 12px;
}

.show-response__ok {
  color: #1c7c43;
  font-weight: 600;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
}

.d-modal__buttons {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 2rem;
  border-top: 1px solid #eee;
  margin: 0;
}

.d-modal__buttons > div {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.d-modal__content {
  padding: 1rem;
  overscroll-behavior: contain;
}

.d-input-group--toggler {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
}

.d-input-group--toggler.d-input-group--toggler--active > .d-label {
  color: var(--dark-blue);
}

.d-input-group--toggler > .d-label {
  margin-bottom: 0;
  cursor: pointer;
}

.d-input-group--toggler:hover {
  background: #f0f8ff;
}

.d-input-group .d-input {
  height: 34px;
}

.d-input-group {
  margin-bottom: 2rem;
}

.d-modal__content {
  max-height: calc(100vh - 52px - 50px);
  overflow-y: auto;
}

.do-form-row {
  display: flex;
  gap: 1rem;
}

.do-form-row > div {
  flex: 1;
}

.height-34 {
  height: 34px;
  margin-top: 0.25rem;
}

</style>



// WEBPACK FOOTER //
// ShowResponse.vue?2c16dd0e